import LinkTo from "components/navigation/link/LinkTo";
import { PHOTO_SIZE_TYPE } from "constant/photo_series/photo_series.constant";
import { PhotoSeries } from "model/photo_series/PhotoSeries";
import styled from "styled-components";
import PhotoFill from "components/common/view_util/image/PhotoFill";

type Props = {
  photoSeries: PhotoSeries;
};

const PhotoSeriesAlbum = ({ photoSeries }: Props) => {
  if (!photoSeries.photos) {
    return <></>;
  }

  const Photos: JSX.Element[] = [];

  for (let i = 0; i < photoSeries.photos.length; i++) {
    const imPath = photoSeries.getPhotoStaticUrl(i, PHOTO_SIZE_TYPE.SMALL);
    const url = photoSeries.getPhotoStaticUrl(i, PHOTO_SIZE_TYPE.LARGE);
    Photos.push(
      <LinkTo
        to={url}
        target="_blank"
        rel="noreferrer"
        key={`album_li_photo_link_${i}`}
      >
        <PhotoFill
          src={imPath}
          alt={photoSeries.photos[i].desc}
          width={150}
          height={150}
        />
      </LinkTo>
    );
  }

  return <Div>{Photos} </Div>;
};

const Div = styled.div`
  display: flex;
  margin-top: 0px;
  gap: 0.3rem;
  flex-wrap: wrap;
  &&& div {
    margin-top: 0;
  }
`;

export default PhotoSeriesAlbum;
